import Link from "next/link";
import classNames from "@/utils/classnames";
import { useGoogleBusinessProfileReviewStats } from "@/components/google-business-profile-review-stats-provider";
import {
  formatGoogleBusinessProfileRatingLabel,
  REVIEWS_PAGE_PATH,
} from "@/lib/google-business-profile-reviews";

type GoogleReviewsTrustLinkProps = {
  className?: string;
  showStar?: boolean;
  variant?: "link" | "pill";
};

export default function GoogleReviewsTrustLink({
  className,
  showStar: _showStar = true,
  variant = "link",
}: GoogleReviewsTrustLinkProps) {
  const stats = useGoogleBusinessProfileReviewStats();
  const label = formatGoogleBusinessProfileRatingLabel(stats);

  if (variant === "pill") {
    return (
      <Link
        href={REVIEWS_PAGE_PATH}
        className={classNames(
          "inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-1.5 text-sm text-gray-700 shadow-sm transition hover:border-brand-200 hover:text-brand-700",
          className,
        )}
      >
        <span className="font-medium tabular-nums">
          {stats.averageRating.toFixed(1)}
        </span>
        <span className="text-gray-400" aria-hidden="true">
          ·
        </span>
        <span>{stats.totalReviewCount} Google reviews</span>
      </Link>
    );
  }

  return (
    <Link href={REVIEWS_PAGE_PATH} className={className}>
      {label}
    </Link>
  );
}
